var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ele-status-dot"},[_c('span',{class:_vm.dotClass,style:(_vm.dotStyle)},[_c('span',{class:_vm.dotColor})]),(_vm.text)?_c('span',{staticClass:"ele-dot-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }